import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  PRIVACY_POLICY_LINK,
  TERMS_OF_USE_LINK_GENERAL,
  UNDERWRITING_LINK,
} from '../../constants';
import { URL_ROOT_QUOTE } from '../../routes';
import {
  useSessionFooter,
  usePartnerNotes,
  useHtmlInjection,
} from '../../hooks';
import { usePartnersData } from '../../partners/usePartnersData';
import { useStickyBarHeight } from '../landing/StickyBarHeightProvider';

import './QuotingFooter.css';

const QuotingFooter = ({
  classContainer = '',
  customFooterText = '',
}) => {
  const notesRef = useRef();
  const footerRef = useRef();
  const sessionFooter = useSessionFooter();
  const [sup1] = usePartnerNotes();
  const { stickyBarHeight } = useStickyBarHeight();
  const { isGoodDog } = usePartnersData();

  useHtmlInjection({
    classNameContainer: 'Quoting-footer-text',
    content: sup1?.Content || '',
    ref: notesRef,
  });

  useHtmlInjection({
    classNameContainer: 'Quoting-footer-text',
    content: customFooterText || sessionFooter,
    elementType: 'p',
    ref: footerRef,
  });

  const location = useLocation();
  const currentLocation = location.pathname.toLocaleLowerCase();
  const marginList = [URL_ROOT_QUOTE];
  const containerStyle = marginList.indexOf(currentLocation) >= 0
    ? 'Quoting-footer-extra-margin' : '';

  const footerClassName = isGoodDog
    ? 'Landing-footer-good-dog' : 'Landing-footer';

  return (
    <footer
      className={`Quoting-footer-container ${containerStyle} ${classContainer}`}
      style={{ marginBottom: stickyBarHeight }}
    >
      <div className="Quoting-footer-content">
        <p className="Quoting-footer-text-header">
          {`Copyright © 2015 – ${new Date().getFullYear()}
           Figo Pet Insurance LLC. All rights reserved.`}
        </p>

        <span className="Quoting-footer-text-spacing">
          <a
            aria-label="privacy policy opens in a new window"
            className="Quoting-footer-links"
            href={PRIVACY_POLICY_LINK}
            rel="noopener noreferrer"
            target="_blank"
          >
            privacy policy
          </a>

          <span className="Quoting-footer-line-separator">{' | '}</span>

          <a
            aria-label="Terms of use and licensing opens in a new window"
            className="Quoting-footer-links"
            href={TERMS_OF_USE_LINK_GENERAL}
            rel="noopener noreferrer"
            target="_blank"
          >
            terms of use &amp; licensing
          </a>

          <span className="Quoting-footer-line-separator">{' | '}</span>

          <a
            aria-label="underwriting opens in a new window"
            className="Quoting-footer-links"
            href={UNDERWRITING_LINK}
            rel="noopener noreferrer"
            target="_blank"
          >
            underwriting
          </a>
        </span>

        <div ref={notesRef} />

        <div ref={footerRef} className={footerClassName} />
      </div>
    </footer>
  );
};

export default QuotingFooter;
